module.exports = "<div class=\"user-messages\">\r\n  <div>\r\n    <div id=\"messages-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n  </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/Components/user-messages/user-messages.html
 ** module id = 672
 ** module chunks = 0
 **/